import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding-bottom: 50px;
  width: 100%;
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: end;
  gap: .5em;

  @media only screen and (max-width: 750px) {
    flex-direction: column;
  }

  a {
    padding: 0;
  }
`;

export const StyledFiltersContainer = styled.div`
  display: flex;
  margin-bottom: 1em;

  @media only screen and (max-width: 750px) {
    flex-direction: column;
  }

  .text-input {
    flex-grow: 1;
    margin-bottom: .5em;
    max-width: 50%;
    min-width: 500px;

    @media only screen and (max-width: 750px) {
      max-width: 100%;
    }
  }
`;
